<template>
  <div class="w-full p-4 flex flex-col items-center">
    <div class="w-full flex items-enter h-24px">
      <Icon
        name="close-circle"
        class="cursor-pointer absolute right-4 z-1 w-25px"
        @click="emit('done')"
      ></Icon>
    </div>

    <Img
      name="ld-greet"
      class="w-85px"
    />

    <div class="text-19px font-semibold mt-3 mb-2">
      {{ _t('common.low_volume') }}
    </div>
    <div class="text-17px font-semibold text-ld-label-secondary">
      {{ _t('common.up_volume') }}
    </div>

    <Button
      class="w-full mt-4"
      :label="_t('common.got')"
      @click="emit('done')"
    />
  </div>
</template>
<script lang="ts" setup>
const emit = defineEmits<{
  done: []
}>()
</script>
<style scoped></style>
